import React, { Component } from 'react';
import ClickOutHandler from 'react-onclickout';
import './FloatingMenu.scss';
import { browserHistory } from '../../browserHistory';
import { FaChevronLeft, FaChevronRight } from 'react-icons/all';

interface State {
  isFloatingMenuContentOpen: boolean;
  currentPageAddress: string;
  mainFloatingMenuClass: string;
}

const pagesNotToShowMenu = [
  '/dashboard',
  '/planner',
  '/tools/address-fix',
  '/routes',
  '/shift',
  '/orders/search',
  '/invoiceCourier',
];

const floatMenuClass = 'floating-menu';
const floatMenuCloseClass = `${floatMenuClass} close`;
const floatMenuOpenClass = `${floatMenuClass} open`;

//Can be reused but it is necessary to make nested styling in the desired component to overwrite existing styling. The only attribute to style is 'top';
export default class FloatingMenu extends Component<any, State> {
  constructor(props) {
    super(props);
    this.state = {
      isFloatingMenuContentOpen: false,
      currentPageAddress: window.location.pathname,
      mainFloatingMenuClass: 'floating-menu',
    };
    browserHistory.listen(location => {
      this.setState({
        currentPageAddress: location.pathname,
        isFloatingMenuContentOpen: false,
        mainFloatingMenuClass: floatMenuCloseClass,
      });
    });
  }

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
  }

  onClickOut = () =>
    this.setState({
      isFloatingMenuContentOpen: false,
      mainFloatingMenuClass: floatMenuCloseClass,
    });

  escFunction = event => {
    if (event.keyCode === 27) {
      this.setState({
        isFloatingMenuContentOpen: false,
        mainFloatingMenuClass: floatMenuCloseClass,
      });
    }
  };

  toggleFloatingContent = () => {
    const { isFloatingMenuContentOpen } = this.state;

    this.setState({
      isFloatingMenuContentOpen: !isFloatingMenuContentOpen,
      mainFloatingMenuClass: isFloatingMenuContentOpen
        ? floatMenuCloseClass
        : floatMenuOpenClass,
    });
  };

  render() {
    const {
      mainFloatingMenuClass,
      isFloatingMenuContentOpen,
      currentPageAddress,
    } = this.state;
    if (pagesNotToShowMenu.includes(currentPageAddress)) return null;

    const { children } = this.props;
    return (
      <ClickOutHandler onClickOut={this.onClickOut}>
        <div className={mainFloatingMenuClass}>
          <div
            className="floating-menu-button"
            onClick={this.toggleFloatingContent}
          >
            {isFloatingMenuContentOpen ? (
              <FaChevronRight onClick={this.toggleFloatingContent} />
            ) : (
              <FaChevronLeft onClick={this.toggleFloatingContent} />
            )}
          </div>
          <div className="floating-menu-content">{children}</div>
        </div>
      </ClickOutHandler>
    );
  }
}
